import { Component } from '@angular/core';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import { ReportsService } from '../../../Model/Reports/reports.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { CommonService } from '../../../Model/Common/common.service';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../../Loader/loader/loader.component';

@Component({
  selector: 'app-essdevice-duplicate-front',
  standalone: true,
  imports: [CommonModule, LoaderComponent],
  templateUrl: './essdevice-duplicate-front.component.html',
  styleUrl: './essdevice-duplicate-front.component.scss'
})
export class ESSDeviceDuplicateFrontComponent {
  isDisabled: boolean = false;
  constructor(
    protected common: CommonService,
    private report: ReportsService,
    private toast: ToastService,
    private download: DownloadSampleService,
  ) {
    this.common.PageRight.IsPrint = true;
    //this.common.getPageRights();
  }

  ngOnInit(): void { }

  ESS_DeviceReport() {
    this.isDisabled = true;

    this.report.ESS_DeviceReport({ SelectType: 'DuplicateEmpMapping' }).subscribe({
      next: (response) => {
        if (response.Table && response.Table.length > 0) {
          this.download.exportInChunks(response.Table, "SiteDateWiseManpower");
          this.isDisabled = false;
        }
        else {
          this.isDisabled = false;
          this.toast.show({ message: 'Data not found!', type: toastTypeEnum.warning });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
}
